export enum CommunicationMessageType {
    PREPARE_SWITCH_MESSAGE = "prepareSwitchMessage",
    EXECUTE_SWITCH_MESSAGE = "executeSwitchMessage",
    COMMUNICATION_STRATEGY_MESSAGE = "communicationStrategyMessage",
    LIVEKIT_INVITATION_MESSAGE = "livekitInvitationMessage",
    LIVEKIT_DISCONNECT_MESSAGE = "livekitDisconnectMessage",
}
